import { computeCid as computeCidV1, isCidV1 } from '@/crypto/cid';

/**
 * 计算内容寻址 CIDv1（raw + sha2-256 + base32）——与中继 ContentHost 一致。
 * 修复：旧实现为 'b' + sha256(hex)，与服务器 base32 不一致，导致图片字节按 base32
 * 落盘中继、manifest 却记录 hex cid，其他端按 hex 拉取必然 miss（v3.6.3）。
 */
export function computeCid(bytes: Uint8Array): string {
  return computeCidV1(bytes);
}

/** 校验字符串是否合法 CIDv1（b + 58 位 base32，RFC4648 小写）。 */
export function isCid(value: string): boolean {
  return isCidV1(value);
}
